import {
  Data_Pipeline_Img,
  Model_FineTuning_Img,
  Scalable_Integration_Img,
  Services_Bg,
} from "../../images";

export default function OurServices() {
  const services = [
    {
      id: 1,
      title: "Model Fine-Tuning",
      description:
        "Prompting, domain adaptation, supervised fine-tuning & RLHF.",
      image: Model_FineTuning_Img,
    },
    {
      id: 2,
      title: "Data Pipeline & Evaluation",
      description:
        "Curated datasets, ethical annotation & structured model testing.",
      image: Data_Pipeline_Img,
    },
    {
      id: 3,
      title: "Scalable Integrations",
      description:
        "Works with OpenAI, Google, Adobe and leading open-source stacks.",
      image: Scalable_Integration_Img,
    },
  ];

  return (
    <section
      className="relative py-20 bg-left-bottom md:bg-center bg-cover md:bg-cover"
      style={{
        backgroundImage: `url("${Services_Bg}")`,
      }}
    >
      <div className="container mx-auto">
        {/* Header */}
        <div className="mb-8 text-center">
          <h1 className="mb-2 text-2xl md:text-3xl font-bold tracking-tight xl:text-[36px] text-[#FFF]">
            Our Services
          </h1>
          <p className="mx-auto max-w-5xl font-normal text-base text-white">
            End-to-End AI Solutions for Real-World Impact
          </p>
        </div>

        {/* Service Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-y-6 md:gap-8">
          {services.map((service) => (
            <div
              key={service.id}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300 col-span-1 md:col-span-6 lg:col-span-4"
            >
              {/* Image Container */}
              <div className="relative h-[240px] md:h-72 flex items-center justify-center p-6">
                <img
                  src={service.image || "/placeholder.svg"}
                  alt={service.title}
                  className="w-full h-full object-contain"
                />
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-lg md:text-2xl font-bold mb-2 md:mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
